<template>
  <div>
    <label
      class="vs-input--label required">
      {{ $t('TextAreaName') }}
    </label>
    <vs-textarea
      v-model="localValue"
      :class="{'border-danger': errors.has($t('TextAreaName'))}"
      style="min-height: 8rem !important;"/>
    <vs-input
      v-model="localValue"
      type="hidden"
      class="w-full"
      :name="$t('TextAreaName')"
      v-validate="'required|max:5000'"
      :danger="errors.has($t('TextAreaName'))"
      :danger-text="errors.first($t('TextAreaName'))"/>
  </div>
</template>

<script>
/**
 * comments for feedback modal
 *
 * @module layouts/components/feedback/TheContactModalComments
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-prop {string} value - comments
 * @vue-data {string} localValue - comments entered by the user
 */
export default {
  name: 'TheContactModalComments',
  i18n: {
    messages: {
      en: {
        TextAreaName: 'Message',
      },
    },
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(value) {
      this.localValue = value;
    },
    localValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
